// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"7075a841","104":"f9b17c45","183":"a852745c","320":"ab515c7c","475":"5cea6f66","651":"751ab09c","728":"0a7b56f0","847":"bab954bf"}[chunkId] + ".chunk.js";
};